/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as protectedRouteRouteImport } from './routes/(protected)/route'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as protectedManagementRouteRouteImport } from './routes/(protected)/management/route'
import { Route as protectedStaffIndexRouteImport } from './routes/(protected)/staff/index'
import { Route as protectedSchedulingIndexRouteImport } from './routes/(protected)/scheduling/index'
import { Route as protectedManagementIndexRouteImport } from './routes/(protected)/management/index'
import { Route as protectedLogisticIndexRouteImport } from './routes/(protected)/logistic/index'
import { Route as protectedGamificationIndexRouteImport } from './routes/(protected)/gamification/index'
import { Route as protectedDashboardIndexRouteImport } from './routes/(protected)/dashboard/index'
import { Route as protectedAthletesIndexRouteImport } from './routes/(protected)/athletes/index'
import { Route as authSignInIndexRouteImport } from './routes/(auth)/sign-in/index'
import { Route as authResetPasswordIndexRouteImport } from './routes/(auth)/reset-password/index'
import { Route as authForgotPasswordIndexRouteImport } from './routes/(auth)/forgot-password/index'
import { Route as protectedStaffNewIndexRouteImport } from './routes/(protected)/staff/new/index'
import { Route as protectedStaffStaffMemberIdIndexRouteImport } from './routes/(protected)/staff/$staffMemberId/index'
import { Route as protectedSchedulingSchedulesIndexRouteImport } from './routes/(protected)/scheduling/schedules/index'
import { Route as protectedSchedulingEventIdIndexRouteImport } from './routes/(protected)/scheduling/$eventId/index'
import { Route as protectedManagementExercisesIndexRouteImport } from './routes/(protected)/management/exercises/index'
import { Route as protectedManagementDisciplinesIndexRouteImport } from './routes/(protected)/management/disciplines/index'
import { Route as protectedManagementDashboardIndexRouteImport } from './routes/(protected)/management/dashboard/index'
import { Route as protectedLogisticRoomsIndexRouteImport } from './routes/(protected)/logistic/rooms/index'
import { Route as protectedLogisticExercisesIndexRouteImport } from './routes/(protected)/logistic/exercises/index'
import { Route as protectedLogisticDisciplinesIndexRouteImport } from './routes/(protected)/logistic/disciplines/index'
import { Route as protectedGamificationRankingIndexRouteImport } from './routes/(protected)/gamification/ranking/index'
import { Route as protectedGamificationChallengesIndexRouteImport } from './routes/(protected)/gamification/challenges/index'
import { Route as protectedAthletesNewIndexRouteImport } from './routes/(protected)/athletes/new/index'
import { Route as protectedAthletesAthleteIdIndexRouteImport } from './routes/(protected)/athletes/$athleteId/index'
import { Route as protectedSchedulingEventsNewIndexRouteImport } from './routes/(protected)/scheduling/events/new/index'
import { Route as protectedSchedulingEventIdEditIndexRouteImport } from './routes/(protected)/scheduling/$eventId/edit/index'
import { Route as protectedManagementExercisesNewIndexRouteImport } from './routes/(protected)/management/exercises/new/index'
import { Route as protectedManagementExercisesExerciseIdIndexRouteImport } from './routes/(protected)/management/exercises/$exerciseId/index'
import { Route as protectedManagementDisciplinesNewIndexRouteImport } from './routes/(protected)/management/disciplines/new/index'
import { Route as protectedManagementDisciplinesDisciplineIdIndexRouteImport } from './routes/(protected)/management/disciplines/$disciplineId/index'
import { Route as protectedLogisticRoomsNewIndexRouteImport } from './routes/(protected)/logistic/rooms/new/index'
import { Route as protectedLogisticRoomsRoomIdIndexRouteImport } from './routes/(protected)/logistic/rooms/$roomId/index'
import { Route as protectedSchedulingSchedulesScheduleIdEditIndexRouteImport } from './routes/(protected)/scheduling/schedules/$scheduleId/edit/index'
import { Route as protectedAthletesAthleteIdWorkoutPlansNewIndexRouteImport } from './routes/(protected)/athletes/$athleteId/workout-plans/new/index'
import { Route as protectedAthletesAthleteIdWorkoutBlocksNewIndexRouteImport } from './routes/(protected)/athletes/$athleteId/workout-blocks/new/index'
import { Route as protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRouteImport } from './routes/(protected)/athletes/$athleteId/workout-blocks/$workoutBlockId/index'
import { Route as protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRouteImport } from './routes/(protected)/athletes/$athleteId/workout-plans/$workoutPlanId/edit/index'
import { Route as protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRouteImport } from './routes/(protected)/athletes/$athleteId/workout-blocks/$workoutBlockId/edit/index'

const protectedRouteRoute = protectedRouteRouteImport.update({
  id: '/(protected)',
  getParentRoute: () => rootRouteImport,
} as any)
const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const protectedManagementRouteRoute =
  protectedManagementRouteRouteImport.update({
    id: '/management',
    path: '/management',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedStaffIndexRoute = protectedStaffIndexRouteImport.update({
  id: '/staff/',
  path: '/staff/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedSchedulingIndexRoute =
  protectedSchedulingIndexRouteImport.update({
    id: '/scheduling/',
    path: '/scheduling/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedManagementIndexRoute =
  protectedManagementIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => protectedManagementRouteRoute,
  } as any)
const protectedLogisticIndexRoute = protectedLogisticIndexRouteImport.update({
  id: '/logistic/',
  path: '/logistic/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedGamificationIndexRoute =
  protectedGamificationIndexRouteImport.update({
    id: '/gamification/',
    path: '/gamification/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedDashboardIndexRoute = protectedDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedAthletesIndexRoute = protectedAthletesIndexRouteImport.update({
  id: '/athletes/',
  path: '/athletes/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const authSignInIndexRoute = authSignInIndexRouteImport.update({
  id: '/sign-in/',
  path: '/sign-in/',
  getParentRoute: () => authRouteRoute,
} as any)
const authResetPasswordIndexRoute = authResetPasswordIndexRouteImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => authRouteRoute,
} as any)
const authForgotPasswordIndexRoute = authForgotPasswordIndexRouteImport.update({
  id: '/forgot-password/',
  path: '/forgot-password/',
  getParentRoute: () => authRouteRoute,
} as any)
const protectedStaffNewIndexRoute = protectedStaffNewIndexRouteImport.update({
  id: '/staff/new/',
  path: '/staff/new/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedStaffStaffMemberIdIndexRoute =
  protectedStaffStaffMemberIdIndexRouteImport.update({
    id: '/staff/$staffMemberId/',
    path: '/staff/$staffMemberId/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedSchedulingSchedulesIndexRoute =
  protectedSchedulingSchedulesIndexRouteImport.update({
    id: '/scheduling/schedules/',
    path: '/scheduling/schedules/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedSchedulingEventIdIndexRoute =
  protectedSchedulingEventIdIndexRouteImport.update({
    id: '/scheduling/$eventId/',
    path: '/scheduling/$eventId/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedManagementExercisesIndexRoute =
  protectedManagementExercisesIndexRouteImport.update({
    id: '/exercises/',
    path: '/exercises/',
    getParentRoute: () => protectedManagementRouteRoute,
  } as any)
const protectedManagementDisciplinesIndexRoute =
  protectedManagementDisciplinesIndexRouteImport.update({
    id: '/disciplines/',
    path: '/disciplines/',
    getParentRoute: () => protectedManagementRouteRoute,
  } as any)
const protectedManagementDashboardIndexRoute =
  protectedManagementDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => protectedManagementRouteRoute,
  } as any)
const protectedLogisticRoomsIndexRoute =
  protectedLogisticRoomsIndexRouteImport.update({
    id: '/logistic/rooms/',
    path: '/logistic/rooms/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedLogisticExercisesIndexRoute =
  protectedLogisticExercisesIndexRouteImport.update({
    id: '/logistic/exercises/',
    path: '/logistic/exercises/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedLogisticDisciplinesIndexRoute =
  protectedLogisticDisciplinesIndexRouteImport.update({
    id: '/logistic/disciplines/',
    path: '/logistic/disciplines/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedGamificationRankingIndexRoute =
  protectedGamificationRankingIndexRouteImport.update({
    id: '/gamification/ranking/',
    path: '/gamification/ranking/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedGamificationChallengesIndexRoute =
  protectedGamificationChallengesIndexRouteImport.update({
    id: '/gamification/challenges/',
    path: '/gamification/challenges/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedAthletesNewIndexRoute =
  protectedAthletesNewIndexRouteImport.update({
    id: '/athletes/new/',
    path: '/athletes/new/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedAthletesAthleteIdIndexRoute =
  protectedAthletesAthleteIdIndexRouteImport.update({
    id: '/athletes/$athleteId/',
    path: '/athletes/$athleteId/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedSchedulingEventsNewIndexRoute =
  protectedSchedulingEventsNewIndexRouteImport.update({
    id: '/scheduling/events/new/',
    path: '/scheduling/events/new/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedSchedulingEventIdEditIndexRoute =
  protectedSchedulingEventIdEditIndexRouteImport.update({
    id: '/scheduling/$eventId/edit/',
    path: '/scheduling/$eventId/edit/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedManagementExercisesNewIndexRoute =
  protectedManagementExercisesNewIndexRouteImport.update({
    id: '/exercises/new/',
    path: '/exercises/new/',
    getParentRoute: () => protectedManagementRouteRoute,
  } as any)
const protectedManagementExercisesExerciseIdIndexRoute =
  protectedManagementExercisesExerciseIdIndexRouteImport.update({
    id: '/exercises/$exerciseId/',
    path: '/exercises/$exerciseId/',
    getParentRoute: () => protectedManagementRouteRoute,
  } as any)
const protectedManagementDisciplinesNewIndexRoute =
  protectedManagementDisciplinesNewIndexRouteImport.update({
    id: '/disciplines/new/',
    path: '/disciplines/new/',
    getParentRoute: () => protectedManagementRouteRoute,
  } as any)
const protectedManagementDisciplinesDisciplineIdIndexRoute =
  protectedManagementDisciplinesDisciplineIdIndexRouteImport.update({
    id: '/disciplines/$disciplineId/',
    path: '/disciplines/$disciplineId/',
    getParentRoute: () => protectedManagementRouteRoute,
  } as any)
const protectedLogisticRoomsNewIndexRoute =
  protectedLogisticRoomsNewIndexRouteImport.update({
    id: '/logistic/rooms/new/',
    path: '/logistic/rooms/new/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedLogisticRoomsRoomIdIndexRoute =
  protectedLogisticRoomsRoomIdIndexRouteImport.update({
    id: '/logistic/rooms/$roomId/',
    path: '/logistic/rooms/$roomId/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedSchedulingSchedulesScheduleIdEditIndexRoute =
  protectedSchedulingSchedulesScheduleIdEditIndexRouteImport.update({
    id: '/scheduling/schedules/$scheduleId/edit/',
    path: '/scheduling/schedules/$scheduleId/edit/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedAthletesAthleteIdWorkoutPlansNewIndexRoute =
  protectedAthletesAthleteIdWorkoutPlansNewIndexRouteImport.update({
    id: '/athletes/$athleteId/workout-plans/new/',
    path: '/athletes/$athleteId/workout-plans/new/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedAthletesAthleteIdWorkoutBlocksNewIndexRoute =
  protectedAthletesAthleteIdWorkoutBlocksNewIndexRouteImport.update({
    id: '/athletes/$athleteId/workout-blocks/new/',
    path: '/athletes/$athleteId/workout-blocks/new/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRoute =
  protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRouteImport.update({
    id: '/athletes/$athleteId/workout-blocks/$workoutBlockId/',
    path: '/athletes/$athleteId/workout-blocks/$workoutBlockId/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRoute =
  protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRouteImport.update(
    {
      id: '/athletes/$athleteId/workout-plans/$workoutPlanId/edit/',
      path: '/athletes/$athleteId/workout-plans/$workoutPlanId/edit/',
      getParentRoute: () => protectedRouteRoute,
    } as any,
  )
const protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRoute =
  protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRouteImport.update(
    {
      id: '/athletes/$athleteId/workout-blocks/$workoutBlockId/edit/',
      path: '/athletes/$athleteId/workout-blocks/$workoutBlockId/edit/',
      getParentRoute: () => protectedRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof protectedRouteRouteWithChildren
  '/management': typeof protectedManagementRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordIndexRoute
  '/reset-password': typeof authResetPasswordIndexRoute
  '/sign-in': typeof authSignInIndexRoute
  '/athletes': typeof protectedAthletesIndexRoute
  '/dashboard': typeof protectedDashboardIndexRoute
  '/gamification': typeof protectedGamificationIndexRoute
  '/logistic': typeof protectedLogisticIndexRoute
  '/management/': typeof protectedManagementIndexRoute
  '/scheduling': typeof protectedSchedulingIndexRoute
  '/staff': typeof protectedStaffIndexRoute
  '/athletes/$athleteId': typeof protectedAthletesAthleteIdIndexRoute
  '/athletes/new': typeof protectedAthletesNewIndexRoute
  '/gamification/challenges': typeof protectedGamificationChallengesIndexRoute
  '/gamification/ranking': typeof protectedGamificationRankingIndexRoute
  '/logistic/disciplines': typeof protectedLogisticDisciplinesIndexRoute
  '/logistic/exercises': typeof protectedLogisticExercisesIndexRoute
  '/logistic/rooms': typeof protectedLogisticRoomsIndexRoute
  '/management/dashboard': typeof protectedManagementDashboardIndexRoute
  '/management/disciplines': typeof protectedManagementDisciplinesIndexRoute
  '/management/exercises': typeof protectedManagementExercisesIndexRoute
  '/scheduling/$eventId': typeof protectedSchedulingEventIdIndexRoute
  '/scheduling/schedules': typeof protectedSchedulingSchedulesIndexRoute
  '/staff/$staffMemberId': typeof protectedStaffStaffMemberIdIndexRoute
  '/staff/new': typeof protectedStaffNewIndexRoute
  '/logistic/rooms/$roomId': typeof protectedLogisticRoomsRoomIdIndexRoute
  '/logistic/rooms/new': typeof protectedLogisticRoomsNewIndexRoute
  '/management/disciplines/$disciplineId': typeof protectedManagementDisciplinesDisciplineIdIndexRoute
  '/management/disciplines/new': typeof protectedManagementDisciplinesNewIndexRoute
  '/management/exercises/$exerciseId': typeof protectedManagementExercisesExerciseIdIndexRoute
  '/management/exercises/new': typeof protectedManagementExercisesNewIndexRoute
  '/scheduling/$eventId/edit': typeof protectedSchedulingEventIdEditIndexRoute
  '/scheduling/events/new': typeof protectedSchedulingEventsNewIndexRoute
  '/athletes/$athleteId/workout-blocks/$workoutBlockId': typeof protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRoute
  '/athletes/$athleteId/workout-blocks/new': typeof protectedAthletesAthleteIdWorkoutBlocksNewIndexRoute
  '/athletes/$athleteId/workout-plans/new': typeof protectedAthletesAthleteIdWorkoutPlansNewIndexRoute
  '/scheduling/schedules/$scheduleId/edit': typeof protectedSchedulingSchedulesScheduleIdEditIndexRoute
  '/athletes/$athleteId/workout-blocks/$workoutBlockId/edit': typeof protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRoute
  '/athletes/$athleteId/workout-plans/$workoutPlanId/edit': typeof protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof protectedRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordIndexRoute
  '/reset-password': typeof authResetPasswordIndexRoute
  '/sign-in': typeof authSignInIndexRoute
  '/athletes': typeof protectedAthletesIndexRoute
  '/dashboard': typeof protectedDashboardIndexRoute
  '/gamification': typeof protectedGamificationIndexRoute
  '/logistic': typeof protectedLogisticIndexRoute
  '/management': typeof protectedManagementIndexRoute
  '/scheduling': typeof protectedSchedulingIndexRoute
  '/staff': typeof protectedStaffIndexRoute
  '/athletes/$athleteId': typeof protectedAthletesAthleteIdIndexRoute
  '/athletes/new': typeof protectedAthletesNewIndexRoute
  '/gamification/challenges': typeof protectedGamificationChallengesIndexRoute
  '/gamification/ranking': typeof protectedGamificationRankingIndexRoute
  '/logistic/disciplines': typeof protectedLogisticDisciplinesIndexRoute
  '/logistic/exercises': typeof protectedLogisticExercisesIndexRoute
  '/logistic/rooms': typeof protectedLogisticRoomsIndexRoute
  '/management/dashboard': typeof protectedManagementDashboardIndexRoute
  '/management/disciplines': typeof protectedManagementDisciplinesIndexRoute
  '/management/exercises': typeof protectedManagementExercisesIndexRoute
  '/scheduling/$eventId': typeof protectedSchedulingEventIdIndexRoute
  '/scheduling/schedules': typeof protectedSchedulingSchedulesIndexRoute
  '/staff/$staffMemberId': typeof protectedStaffStaffMemberIdIndexRoute
  '/staff/new': typeof protectedStaffNewIndexRoute
  '/logistic/rooms/$roomId': typeof protectedLogisticRoomsRoomIdIndexRoute
  '/logistic/rooms/new': typeof protectedLogisticRoomsNewIndexRoute
  '/management/disciplines/$disciplineId': typeof protectedManagementDisciplinesDisciplineIdIndexRoute
  '/management/disciplines/new': typeof protectedManagementDisciplinesNewIndexRoute
  '/management/exercises/$exerciseId': typeof protectedManagementExercisesExerciseIdIndexRoute
  '/management/exercises/new': typeof protectedManagementExercisesNewIndexRoute
  '/scheduling/$eventId/edit': typeof protectedSchedulingEventIdEditIndexRoute
  '/scheduling/events/new': typeof protectedSchedulingEventsNewIndexRoute
  '/athletes/$athleteId/workout-blocks/$workoutBlockId': typeof protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRoute
  '/athletes/$athleteId/workout-blocks/new': typeof protectedAthletesAthleteIdWorkoutBlocksNewIndexRoute
  '/athletes/$athleteId/workout-plans/new': typeof protectedAthletesAthleteIdWorkoutPlansNewIndexRoute
  '/scheduling/schedules/$scheduleId/edit': typeof protectedSchedulingSchedulesScheduleIdEditIndexRoute
  '/athletes/$athleteId/workout-blocks/$workoutBlockId/edit': typeof protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRoute
  '/athletes/$athleteId/workout-plans/$workoutPlanId/edit': typeof protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(auth)': typeof authRouteRouteWithChildren
  '/(protected)': typeof protectedRouteRouteWithChildren
  '/(protected)/management': typeof protectedManagementRouteRouteWithChildren
  '/(auth)/forgot-password/': typeof authForgotPasswordIndexRoute
  '/(auth)/reset-password/': typeof authResetPasswordIndexRoute
  '/(auth)/sign-in/': typeof authSignInIndexRoute
  '/(protected)/athletes/': typeof protectedAthletesIndexRoute
  '/(protected)/dashboard/': typeof protectedDashboardIndexRoute
  '/(protected)/gamification/': typeof protectedGamificationIndexRoute
  '/(protected)/logistic/': typeof protectedLogisticIndexRoute
  '/(protected)/management/': typeof protectedManagementIndexRoute
  '/(protected)/scheduling/': typeof protectedSchedulingIndexRoute
  '/(protected)/staff/': typeof protectedStaffIndexRoute
  '/(protected)/athletes/$athleteId/': typeof protectedAthletesAthleteIdIndexRoute
  '/(protected)/athletes/new/': typeof protectedAthletesNewIndexRoute
  '/(protected)/gamification/challenges/': typeof protectedGamificationChallengesIndexRoute
  '/(protected)/gamification/ranking/': typeof protectedGamificationRankingIndexRoute
  '/(protected)/logistic/disciplines/': typeof protectedLogisticDisciplinesIndexRoute
  '/(protected)/logistic/exercises/': typeof protectedLogisticExercisesIndexRoute
  '/(protected)/logistic/rooms/': typeof protectedLogisticRoomsIndexRoute
  '/(protected)/management/dashboard/': typeof protectedManagementDashboardIndexRoute
  '/(protected)/management/disciplines/': typeof protectedManagementDisciplinesIndexRoute
  '/(protected)/management/exercises/': typeof protectedManagementExercisesIndexRoute
  '/(protected)/scheduling/$eventId/': typeof protectedSchedulingEventIdIndexRoute
  '/(protected)/scheduling/schedules/': typeof protectedSchedulingSchedulesIndexRoute
  '/(protected)/staff/$staffMemberId/': typeof protectedStaffStaffMemberIdIndexRoute
  '/(protected)/staff/new/': typeof protectedStaffNewIndexRoute
  '/(protected)/logistic/rooms/$roomId/': typeof protectedLogisticRoomsRoomIdIndexRoute
  '/(protected)/logistic/rooms/new/': typeof protectedLogisticRoomsNewIndexRoute
  '/(protected)/management/disciplines/$disciplineId/': typeof protectedManagementDisciplinesDisciplineIdIndexRoute
  '/(protected)/management/disciplines/new/': typeof protectedManagementDisciplinesNewIndexRoute
  '/(protected)/management/exercises/$exerciseId/': typeof protectedManagementExercisesExerciseIdIndexRoute
  '/(protected)/management/exercises/new/': typeof protectedManagementExercisesNewIndexRoute
  '/(protected)/scheduling/$eventId/edit/': typeof protectedSchedulingEventIdEditIndexRoute
  '/(protected)/scheduling/events/new/': typeof protectedSchedulingEventsNewIndexRoute
  '/(protected)/athletes/$athleteId/workout-blocks/$workoutBlockId/': typeof protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRoute
  '/(protected)/athletes/$athleteId/workout-blocks/new/': typeof protectedAthletesAthleteIdWorkoutBlocksNewIndexRoute
  '/(protected)/athletes/$athleteId/workout-plans/new/': typeof protectedAthletesAthleteIdWorkoutPlansNewIndexRoute
  '/(protected)/scheduling/schedules/$scheduleId/edit/': typeof protectedSchedulingSchedulesScheduleIdEditIndexRoute
  '/(protected)/athletes/$athleteId/workout-blocks/$workoutBlockId/edit/': typeof protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRoute
  '/(protected)/athletes/$athleteId/workout-plans/$workoutPlanId/edit/': typeof protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/management'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/athletes'
    | '/dashboard'
    | '/gamification'
    | '/logistic'
    | '/management/'
    | '/scheduling'
    | '/staff'
    | '/athletes/$athleteId'
    | '/athletes/new'
    | '/gamification/challenges'
    | '/gamification/ranking'
    | '/logistic/disciplines'
    | '/logistic/exercises'
    | '/logistic/rooms'
    | '/management/dashboard'
    | '/management/disciplines'
    | '/management/exercises'
    | '/scheduling/$eventId'
    | '/scheduling/schedules'
    | '/staff/$staffMemberId'
    | '/staff/new'
    | '/logistic/rooms/$roomId'
    | '/logistic/rooms/new'
    | '/management/disciplines/$disciplineId'
    | '/management/disciplines/new'
    | '/management/exercises/$exerciseId'
    | '/management/exercises/new'
    | '/scheduling/$eventId/edit'
    | '/scheduling/events/new'
    | '/athletes/$athleteId/workout-blocks/$workoutBlockId'
    | '/athletes/$athleteId/workout-blocks/new'
    | '/athletes/$athleteId/workout-plans/new'
    | '/scheduling/schedules/$scheduleId/edit'
    | '/athletes/$athleteId/workout-blocks/$workoutBlockId/edit'
    | '/athletes/$athleteId/workout-plans/$workoutPlanId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/athletes'
    | '/dashboard'
    | '/gamification'
    | '/logistic'
    | '/management'
    | '/scheduling'
    | '/staff'
    | '/athletes/$athleteId'
    | '/athletes/new'
    | '/gamification/challenges'
    | '/gamification/ranking'
    | '/logistic/disciplines'
    | '/logistic/exercises'
    | '/logistic/rooms'
    | '/management/dashboard'
    | '/management/disciplines'
    | '/management/exercises'
    | '/scheduling/$eventId'
    | '/scheduling/schedules'
    | '/staff/$staffMemberId'
    | '/staff/new'
    | '/logistic/rooms/$roomId'
    | '/logistic/rooms/new'
    | '/management/disciplines/$disciplineId'
    | '/management/disciplines/new'
    | '/management/exercises/$exerciseId'
    | '/management/exercises/new'
    | '/scheduling/$eventId/edit'
    | '/scheduling/events/new'
    | '/athletes/$athleteId/workout-blocks/$workoutBlockId'
    | '/athletes/$athleteId/workout-blocks/new'
    | '/athletes/$athleteId/workout-plans/new'
    | '/scheduling/schedules/$scheduleId/edit'
    | '/athletes/$athleteId/workout-blocks/$workoutBlockId/edit'
    | '/athletes/$athleteId/workout-plans/$workoutPlanId/edit'
  id:
    | '__root__'
    | '/'
    | '/(auth)'
    | '/(protected)'
    | '/(protected)/management'
    | '/(auth)/forgot-password/'
    | '/(auth)/reset-password/'
    | '/(auth)/sign-in/'
    | '/(protected)/athletes/'
    | '/(protected)/dashboard/'
    | '/(protected)/gamification/'
    | '/(protected)/logistic/'
    | '/(protected)/management/'
    | '/(protected)/scheduling/'
    | '/(protected)/staff/'
    | '/(protected)/athletes/$athleteId/'
    | '/(protected)/athletes/new/'
    | '/(protected)/gamification/challenges/'
    | '/(protected)/gamification/ranking/'
    | '/(protected)/logistic/disciplines/'
    | '/(protected)/logistic/exercises/'
    | '/(protected)/logistic/rooms/'
    | '/(protected)/management/dashboard/'
    | '/(protected)/management/disciplines/'
    | '/(protected)/management/exercises/'
    | '/(protected)/scheduling/$eventId/'
    | '/(protected)/scheduling/schedules/'
    | '/(protected)/staff/$staffMemberId/'
    | '/(protected)/staff/new/'
    | '/(protected)/logistic/rooms/$roomId/'
    | '/(protected)/logistic/rooms/new/'
    | '/(protected)/management/disciplines/$disciplineId/'
    | '/(protected)/management/disciplines/new/'
    | '/(protected)/management/exercises/$exerciseId/'
    | '/(protected)/management/exercises/new/'
    | '/(protected)/scheduling/$eventId/edit/'
    | '/(protected)/scheduling/events/new/'
    | '/(protected)/athletes/$athleteId/workout-blocks/$workoutBlockId/'
    | '/(protected)/athletes/$athleteId/workout-blocks/new/'
    | '/(protected)/athletes/$athleteId/workout-plans/new/'
    | '/(protected)/scheduling/schedules/$scheduleId/edit/'
    | '/(protected)/athletes/$athleteId/workout-blocks/$workoutBlockId/edit/'
    | '/(protected)/athletes/$athleteId/workout-plans/$workoutPlanId/edit/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  authRouteRoute: typeof authRouteRouteWithChildren
  protectedRouteRoute: typeof protectedRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(protected)': {
      id: '/(protected)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof protectedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)': {
      id: '/(auth)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(protected)/management': {
      id: '/(protected)/management'
      path: '/management'
      fullPath: '/management'
      preLoaderRoute: typeof protectedManagementRouteRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/staff/': {
      id: '/(protected)/staff/'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof protectedStaffIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/scheduling/': {
      id: '/(protected)/scheduling/'
      path: '/scheduling'
      fullPath: '/scheduling'
      preLoaderRoute: typeof protectedSchedulingIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/management/': {
      id: '/(protected)/management/'
      path: '/'
      fullPath: '/management/'
      preLoaderRoute: typeof protectedManagementIndexRouteImport
      parentRoute: typeof protectedManagementRouteRoute
    }
    '/(protected)/logistic/': {
      id: '/(protected)/logistic/'
      path: '/logistic'
      fullPath: '/logistic'
      preLoaderRoute: typeof protectedLogisticIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/gamification/': {
      id: '/(protected)/gamification/'
      path: '/gamification'
      fullPath: '/gamification'
      preLoaderRoute: typeof protectedGamificationIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/dashboard/': {
      id: '/(protected)/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof protectedDashboardIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/athletes/': {
      id: '/(protected)/athletes/'
      path: '/athletes'
      fullPath: '/athletes'
      preLoaderRoute: typeof protectedAthletesIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(auth)/sign-in/': {
      id: '/(auth)/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInIndexRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/reset-password/': {
      id: '/(auth)/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordIndexRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/forgot-password/': {
      id: '/(auth)/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordIndexRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(protected)/staff/new/': {
      id: '/(protected)/staff/new/'
      path: '/staff/new'
      fullPath: '/staff/new'
      preLoaderRoute: typeof protectedStaffNewIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/staff/$staffMemberId/': {
      id: '/(protected)/staff/$staffMemberId/'
      path: '/staff/$staffMemberId'
      fullPath: '/staff/$staffMemberId'
      preLoaderRoute: typeof protectedStaffStaffMemberIdIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/scheduling/schedules/': {
      id: '/(protected)/scheduling/schedules/'
      path: '/scheduling/schedules'
      fullPath: '/scheduling/schedules'
      preLoaderRoute: typeof protectedSchedulingSchedulesIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/scheduling/$eventId/': {
      id: '/(protected)/scheduling/$eventId/'
      path: '/scheduling/$eventId'
      fullPath: '/scheduling/$eventId'
      preLoaderRoute: typeof protectedSchedulingEventIdIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/management/exercises/': {
      id: '/(protected)/management/exercises/'
      path: '/exercises'
      fullPath: '/management/exercises'
      preLoaderRoute: typeof protectedManagementExercisesIndexRouteImport
      parentRoute: typeof protectedManagementRouteRoute
    }
    '/(protected)/management/disciplines/': {
      id: '/(protected)/management/disciplines/'
      path: '/disciplines'
      fullPath: '/management/disciplines'
      preLoaderRoute: typeof protectedManagementDisciplinesIndexRouteImport
      parentRoute: typeof protectedManagementRouteRoute
    }
    '/(protected)/management/dashboard/': {
      id: '/(protected)/management/dashboard/'
      path: '/dashboard'
      fullPath: '/management/dashboard'
      preLoaderRoute: typeof protectedManagementDashboardIndexRouteImport
      parentRoute: typeof protectedManagementRouteRoute
    }
    '/(protected)/logistic/rooms/': {
      id: '/(protected)/logistic/rooms/'
      path: '/logistic/rooms'
      fullPath: '/logistic/rooms'
      preLoaderRoute: typeof protectedLogisticRoomsIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/logistic/exercises/': {
      id: '/(protected)/logistic/exercises/'
      path: '/logistic/exercises'
      fullPath: '/logistic/exercises'
      preLoaderRoute: typeof protectedLogisticExercisesIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/logistic/disciplines/': {
      id: '/(protected)/logistic/disciplines/'
      path: '/logistic/disciplines'
      fullPath: '/logistic/disciplines'
      preLoaderRoute: typeof protectedLogisticDisciplinesIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/gamification/ranking/': {
      id: '/(protected)/gamification/ranking/'
      path: '/gamification/ranking'
      fullPath: '/gamification/ranking'
      preLoaderRoute: typeof protectedGamificationRankingIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/gamification/challenges/': {
      id: '/(protected)/gamification/challenges/'
      path: '/gamification/challenges'
      fullPath: '/gamification/challenges'
      preLoaderRoute: typeof protectedGamificationChallengesIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/athletes/new/': {
      id: '/(protected)/athletes/new/'
      path: '/athletes/new'
      fullPath: '/athletes/new'
      preLoaderRoute: typeof protectedAthletesNewIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/athletes/$athleteId/': {
      id: '/(protected)/athletes/$athleteId/'
      path: '/athletes/$athleteId'
      fullPath: '/athletes/$athleteId'
      preLoaderRoute: typeof protectedAthletesAthleteIdIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/scheduling/events/new/': {
      id: '/(protected)/scheduling/events/new/'
      path: '/scheduling/events/new'
      fullPath: '/scheduling/events/new'
      preLoaderRoute: typeof protectedSchedulingEventsNewIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/scheduling/$eventId/edit/': {
      id: '/(protected)/scheduling/$eventId/edit/'
      path: '/scheduling/$eventId/edit'
      fullPath: '/scheduling/$eventId/edit'
      preLoaderRoute: typeof protectedSchedulingEventIdEditIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/management/exercises/new/': {
      id: '/(protected)/management/exercises/new/'
      path: '/exercises/new'
      fullPath: '/management/exercises/new'
      preLoaderRoute: typeof protectedManagementExercisesNewIndexRouteImport
      parentRoute: typeof protectedManagementRouteRoute
    }
    '/(protected)/management/exercises/$exerciseId/': {
      id: '/(protected)/management/exercises/$exerciseId/'
      path: '/exercises/$exerciseId'
      fullPath: '/management/exercises/$exerciseId'
      preLoaderRoute: typeof protectedManagementExercisesExerciseIdIndexRouteImport
      parentRoute: typeof protectedManagementRouteRoute
    }
    '/(protected)/management/disciplines/new/': {
      id: '/(protected)/management/disciplines/new/'
      path: '/disciplines/new'
      fullPath: '/management/disciplines/new'
      preLoaderRoute: typeof protectedManagementDisciplinesNewIndexRouteImport
      parentRoute: typeof protectedManagementRouteRoute
    }
    '/(protected)/management/disciplines/$disciplineId/': {
      id: '/(protected)/management/disciplines/$disciplineId/'
      path: '/disciplines/$disciplineId'
      fullPath: '/management/disciplines/$disciplineId'
      preLoaderRoute: typeof protectedManagementDisciplinesDisciplineIdIndexRouteImport
      parentRoute: typeof protectedManagementRouteRoute
    }
    '/(protected)/logistic/rooms/new/': {
      id: '/(protected)/logistic/rooms/new/'
      path: '/logistic/rooms/new'
      fullPath: '/logistic/rooms/new'
      preLoaderRoute: typeof protectedLogisticRoomsNewIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/logistic/rooms/$roomId/': {
      id: '/(protected)/logistic/rooms/$roomId/'
      path: '/logistic/rooms/$roomId'
      fullPath: '/logistic/rooms/$roomId'
      preLoaderRoute: typeof protectedLogisticRoomsRoomIdIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/scheduling/schedules/$scheduleId/edit/': {
      id: '/(protected)/scheduling/schedules/$scheduleId/edit/'
      path: '/scheduling/schedules/$scheduleId/edit'
      fullPath: '/scheduling/schedules/$scheduleId/edit'
      preLoaderRoute: typeof protectedSchedulingSchedulesScheduleIdEditIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/athletes/$athleteId/workout-plans/new/': {
      id: '/(protected)/athletes/$athleteId/workout-plans/new/'
      path: '/athletes/$athleteId/workout-plans/new'
      fullPath: '/athletes/$athleteId/workout-plans/new'
      preLoaderRoute: typeof protectedAthletesAthleteIdWorkoutPlansNewIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/athletes/$athleteId/workout-blocks/new/': {
      id: '/(protected)/athletes/$athleteId/workout-blocks/new/'
      path: '/athletes/$athleteId/workout-blocks/new'
      fullPath: '/athletes/$athleteId/workout-blocks/new'
      preLoaderRoute: typeof protectedAthletesAthleteIdWorkoutBlocksNewIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/athletes/$athleteId/workout-blocks/$workoutBlockId/': {
      id: '/(protected)/athletes/$athleteId/workout-blocks/$workoutBlockId/'
      path: '/athletes/$athleteId/workout-blocks/$workoutBlockId'
      fullPath: '/athletes/$athleteId/workout-blocks/$workoutBlockId'
      preLoaderRoute: typeof protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/athletes/$athleteId/workout-plans/$workoutPlanId/edit/': {
      id: '/(protected)/athletes/$athleteId/workout-plans/$workoutPlanId/edit/'
      path: '/athletes/$athleteId/workout-plans/$workoutPlanId/edit'
      fullPath: '/athletes/$athleteId/workout-plans/$workoutPlanId/edit'
      preLoaderRoute: typeof protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/athletes/$athleteId/workout-blocks/$workoutBlockId/edit/': {
      id: '/(protected)/athletes/$athleteId/workout-blocks/$workoutBlockId/edit/'
      path: '/athletes/$athleteId/workout-blocks/$workoutBlockId/edit'
      fullPath: '/athletes/$athleteId/workout-blocks/$workoutBlockId/edit'
      preLoaderRoute: typeof protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
  }
}

interface authRouteRouteChildren {
  authForgotPasswordIndexRoute: typeof authForgotPasswordIndexRoute
  authResetPasswordIndexRoute: typeof authResetPasswordIndexRoute
  authSignInIndexRoute: typeof authSignInIndexRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authForgotPasswordIndexRoute: authForgotPasswordIndexRoute,
  authResetPasswordIndexRoute: authResetPasswordIndexRoute,
  authSignInIndexRoute: authSignInIndexRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

interface protectedManagementRouteRouteChildren {
  protectedManagementIndexRoute: typeof protectedManagementIndexRoute
  protectedManagementDashboardIndexRoute: typeof protectedManagementDashboardIndexRoute
  protectedManagementDisciplinesIndexRoute: typeof protectedManagementDisciplinesIndexRoute
  protectedManagementExercisesIndexRoute: typeof protectedManagementExercisesIndexRoute
  protectedManagementDisciplinesDisciplineIdIndexRoute: typeof protectedManagementDisciplinesDisciplineIdIndexRoute
  protectedManagementDisciplinesNewIndexRoute: typeof protectedManagementDisciplinesNewIndexRoute
  protectedManagementExercisesExerciseIdIndexRoute: typeof protectedManagementExercisesExerciseIdIndexRoute
  protectedManagementExercisesNewIndexRoute: typeof protectedManagementExercisesNewIndexRoute
}

const protectedManagementRouteRouteChildren: protectedManagementRouteRouteChildren =
  {
    protectedManagementIndexRoute: protectedManagementIndexRoute,
    protectedManagementDashboardIndexRoute:
      protectedManagementDashboardIndexRoute,
    protectedManagementDisciplinesIndexRoute:
      protectedManagementDisciplinesIndexRoute,
    protectedManagementExercisesIndexRoute:
      protectedManagementExercisesIndexRoute,
    protectedManagementDisciplinesDisciplineIdIndexRoute:
      protectedManagementDisciplinesDisciplineIdIndexRoute,
    protectedManagementDisciplinesNewIndexRoute:
      protectedManagementDisciplinesNewIndexRoute,
    protectedManagementExercisesExerciseIdIndexRoute:
      protectedManagementExercisesExerciseIdIndexRoute,
    protectedManagementExercisesNewIndexRoute:
      protectedManagementExercisesNewIndexRoute,
  }

const protectedManagementRouteRouteWithChildren =
  protectedManagementRouteRoute._addFileChildren(
    protectedManagementRouteRouteChildren,
  )

interface protectedRouteRouteChildren {
  protectedManagementRouteRoute: typeof protectedManagementRouteRouteWithChildren
  protectedAthletesIndexRoute: typeof protectedAthletesIndexRoute
  protectedDashboardIndexRoute: typeof protectedDashboardIndexRoute
  protectedGamificationIndexRoute: typeof protectedGamificationIndexRoute
  protectedLogisticIndexRoute: typeof protectedLogisticIndexRoute
  protectedSchedulingIndexRoute: typeof protectedSchedulingIndexRoute
  protectedStaffIndexRoute: typeof protectedStaffIndexRoute
  protectedAthletesAthleteIdIndexRoute: typeof protectedAthletesAthleteIdIndexRoute
  protectedAthletesNewIndexRoute: typeof protectedAthletesNewIndexRoute
  protectedGamificationChallengesIndexRoute: typeof protectedGamificationChallengesIndexRoute
  protectedGamificationRankingIndexRoute: typeof protectedGamificationRankingIndexRoute
  protectedLogisticDisciplinesIndexRoute: typeof protectedLogisticDisciplinesIndexRoute
  protectedLogisticExercisesIndexRoute: typeof protectedLogisticExercisesIndexRoute
  protectedLogisticRoomsIndexRoute: typeof protectedLogisticRoomsIndexRoute
  protectedSchedulingEventIdIndexRoute: typeof protectedSchedulingEventIdIndexRoute
  protectedSchedulingSchedulesIndexRoute: typeof protectedSchedulingSchedulesIndexRoute
  protectedStaffStaffMemberIdIndexRoute: typeof protectedStaffStaffMemberIdIndexRoute
  protectedStaffNewIndexRoute: typeof protectedStaffNewIndexRoute
  protectedLogisticRoomsRoomIdIndexRoute: typeof protectedLogisticRoomsRoomIdIndexRoute
  protectedLogisticRoomsNewIndexRoute: typeof protectedLogisticRoomsNewIndexRoute
  protectedSchedulingEventIdEditIndexRoute: typeof protectedSchedulingEventIdEditIndexRoute
  protectedSchedulingEventsNewIndexRoute: typeof protectedSchedulingEventsNewIndexRoute
  protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRoute: typeof protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRoute
  protectedAthletesAthleteIdWorkoutBlocksNewIndexRoute: typeof protectedAthletesAthleteIdWorkoutBlocksNewIndexRoute
  protectedAthletesAthleteIdWorkoutPlansNewIndexRoute: typeof protectedAthletesAthleteIdWorkoutPlansNewIndexRoute
  protectedSchedulingSchedulesScheduleIdEditIndexRoute: typeof protectedSchedulingSchedulesScheduleIdEditIndexRoute
  protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRoute: typeof protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRoute
  protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRoute: typeof protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRoute
}

const protectedRouteRouteChildren: protectedRouteRouteChildren = {
  protectedManagementRouteRoute: protectedManagementRouteRouteWithChildren,
  protectedAthletesIndexRoute: protectedAthletesIndexRoute,
  protectedDashboardIndexRoute: protectedDashboardIndexRoute,
  protectedGamificationIndexRoute: protectedGamificationIndexRoute,
  protectedLogisticIndexRoute: protectedLogisticIndexRoute,
  protectedSchedulingIndexRoute: protectedSchedulingIndexRoute,
  protectedStaffIndexRoute: protectedStaffIndexRoute,
  protectedAthletesAthleteIdIndexRoute: protectedAthletesAthleteIdIndexRoute,
  protectedAthletesNewIndexRoute: protectedAthletesNewIndexRoute,
  protectedGamificationChallengesIndexRoute:
    protectedGamificationChallengesIndexRoute,
  protectedGamificationRankingIndexRoute:
    protectedGamificationRankingIndexRoute,
  protectedLogisticDisciplinesIndexRoute:
    protectedLogisticDisciplinesIndexRoute,
  protectedLogisticExercisesIndexRoute: protectedLogisticExercisesIndexRoute,
  protectedLogisticRoomsIndexRoute: protectedLogisticRoomsIndexRoute,
  protectedSchedulingEventIdIndexRoute: protectedSchedulingEventIdIndexRoute,
  protectedSchedulingSchedulesIndexRoute:
    protectedSchedulingSchedulesIndexRoute,
  protectedStaffStaffMemberIdIndexRoute: protectedStaffStaffMemberIdIndexRoute,
  protectedStaffNewIndexRoute: protectedStaffNewIndexRoute,
  protectedLogisticRoomsRoomIdIndexRoute:
    protectedLogisticRoomsRoomIdIndexRoute,
  protectedLogisticRoomsNewIndexRoute: protectedLogisticRoomsNewIndexRoute,
  protectedSchedulingEventIdEditIndexRoute:
    protectedSchedulingEventIdEditIndexRoute,
  protectedSchedulingEventsNewIndexRoute:
    protectedSchedulingEventsNewIndexRoute,
  protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRoute:
    protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRoute,
  protectedAthletesAthleteIdWorkoutBlocksNewIndexRoute:
    protectedAthletesAthleteIdWorkoutBlocksNewIndexRoute,
  protectedAthletesAthleteIdWorkoutPlansNewIndexRoute:
    protectedAthletesAthleteIdWorkoutPlansNewIndexRoute,
  protectedSchedulingSchedulesScheduleIdEditIndexRoute:
    protectedSchedulingSchedulesScheduleIdEditIndexRoute,
  protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRoute:
    protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRoute,
  protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRoute:
    protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRoute,
}

const protectedRouteRouteWithChildren = protectedRouteRoute._addFileChildren(
  protectedRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  authRouteRoute: authRouteRouteWithChildren,
  protectedRouteRoute: protectedRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
